import CustomStore from "devextreme/data/custom_store";

import jwtService from "@service/jwt-service";
import { CommonUtil } from "@utils/CommonUtil";
import { CommonConst } from "@constants/common-const";
import DataSource from "devextreme/data/data_source";
import { commonNotify } from "@utils/common";

const Axios = jwtService.axiosIns;

type DesignDataSource = {
  data: Design[];
  totalCount: number;
};

// 전문설계 목록 조회
async function getDesigns(params: any) {
  return await Axios.get<DesignDataSource>(`/designs?${params}`);
}
// 전문설계 목록 조회
async function getCompanyDesigns(companyId: number, params: any) {
  return await Axios.get<DesignDataSource>(`/companies/${companyId}/designs?${params}`);
}

// 전문설계 삭제상태로 수정
async function updateMyDeletedDesign(...args: any) {
  return await Axios.put(`/designs`, ...args);
}

// 전문설계 삭제상태로 수정 - 조직별(운영자)
async function updateCompanyDeletedDesign(companyId: number, ...args: any) {
  return await Axios.put(`/companies/${companyId}/designs`, ...args);
}

// 전문설계 복원상태로 수정
async function updateMyRestoredDesign(id: number, ...args: any) {
  return await Axios.put(`/designs/${id}/restore`, ...args);
}

// 전문설계 복원상태로 수정 - 조직별(운영자)
async function updateCompanyRestoredDesign(companyId: number, id: number, ...args: any) {
  return await Axios.put(`/companies/${companyId}/designs/${id}/restore`, ...args);
}

// 삭제된 전문설계 목록 조회
async function getMyDeletedDesigns(params: any) {
  return await Axios.get<DesignDataSource>(`/designs/deleted?${params}`);
}

// 삭제된 전문설계 목록 조회 - 조직별(운영자)
async function getCompanyDeletedDesigns(companyId: number, params: any) {
  return await Axios.get<DesignDataSource>(`/companies/${companyId}/designs/deleted?${params}`);
}

// 전문설계 삭제
async function deleteDesign(id: number) {
  return await Axios.delete(`/designs/${id}`);
}

// 전문설계 삭제 - 조직별(운영자)
async function deleteCompanyDesign(companyId: number, id: number) {
  return await Axios.delete(`/companies/${companyId}/designs/${id}`);
}

// 전문설계 상세 조회
async function getMyDesignDetail(id: number) {
  return Axios.get<Design>(`/designs/${id}`);
}

// 전문설계 상세 조회 - 조직별(운영자)
async function getCompanyDesignDetail(companyId: number, id: number) {
  return Axios.get<Design>(`/companies/${companyId}/designs/${id}`);
}

// 전문설계 상세 수정
async function updateMyDesignDetail(id: number, ...args: any) {
  return Axios.put(`/designs/${id}`, ...args);
}

// 전문설계 상세 수정 - 조직별(운영자)
async function updateCompanyDesignDetail(companyId: number, id: number, ...args: any) {
  return Axios.put(`/companies/${companyId}/designs/${id}`, ...args);
}

// 전문설계 결과물 공통정보 DTO 조회
async function getMyDesignOutputCommonDTO(id: number) {
  return Axios.get(`/designs/${id}/output/designOutputDTO`);
}

// 전문설계 결과물 공통정보 DTO 조회 - 조직별(운영자)
async function getCompanyDesignOutputCommonDTO(companyId: number, id: number) {
  return Axios.get(`/companies/${companyId}/designs/${id}/output/designOutputDTO`);
}

// 전문설계 결과물 기본정보 DTO 조회
async function getMyDesignOutputBasicDTO(id: number) {
  return Axios.get<Basic>(`/designs/${id}/output/designBasicDTO`);
}

// 전문설계 결과물 기본정보 DTO 조회 - 조직별(운영자)
async function getCompanyDesignOutputBasicDTO(companyId: number, id: number) {
  return Axios.get(`/companies/${companyId}/designs/${id}/output/designBasicDTO`);
}

// 전문설계 설계도 조회
async function getMyDesignBlueprint(id: number) {
  return Axios.get(`/designs/${id}/blueprint/subsidy`);
}

// 전문설계 설계도 조회 - 조직별(운영자)
async function getCompanyDesignBlueprint(companyId: number, id: number) {
  return Axios.get(`/companies/${companyId}/designs/${id}/blueprint/subsidy`);
}

// 전문설계 시방서 조회
async function getMyDesignSpecification(id: number) {
  return Axios.get(`/designs/${id}/spec`);
}

// 전문설계 시방서 조회 - 조직별(운영자)
async function getCompanyDesignSpecification(companyId: number, id: number) {
  return Axios.get(`/companies/${companyId}/designs/${id}/spec`);
}

// 전문설계 자재 내역 조회
async function getMyDesignMaterial(id: number) {
  return Axios.get(`/designs/${id}/material`);
}

// 전문설계 자재 내역 조회 - 조직별(운영자)
async function getCompanyDesignMaterial(companyId: number, id: number) {
  return Axios.get(`/companies/${companyId}/designs/${id}/material`);
}

// 전문설계 설계 내역 조회
async function getMyDesignDetailed(id: number) {
  return Axios.get(`/designs/${id}/detail`);
}

// 전문설계 설계 내역 조회 - 조직별(운영자)
async function getCompanyDesignDetailed(companyId: number, id: number) {
  return Axios.get(`/companies/${companyId}/designs/${id}/detail`);
}

// 전문설계 설계 검색 - 조직별(운영자)
async function getCompanyDesignSearch(companyId: number, params: string) {
  return Axios.get(`/companies/${companyId}/designs/search?${params}`);
}
// 전문설계 설계 검색
async function getSearchDesigns(params: string) {
  return Axios.get(`/designs/search?${params}`);
}

/**
 * 전문설계 목록 조회(Dx)
 */
export function getDesignDataSource(accessType: string, companyId: number = null) {
  return new CustomStore({
    key: "id",
    onLoading() {
      // store.commit("store/setLoading", true);
    },
    onLoaded() {
      // store.commit("store/setLoading", false);
    },
    async load(loadOptions) {
      // 파라미터 생성
      const params = CommonUtil.makeDxDataGridParams(loadOptions);
      try {
        let response;
        if (accessType === CommonConst.ACCESS_TYPE_MY) {
          response = await getDesigns(params);
        } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
          response = await getCompanyDesigns(companyId, params);
        }
        return response.data;
      } catch (e) {
        // store.commit("store/setLoading", false);
        throw new Error("Data Loading Error");
      }
    },
  });
}

/**
 * 삭제된 전문설계 목록 조회(Dx)
 */
export function getDeletedDesignDataSource(accessType: string, companyId: number = null) {
  let response: any;
  return new CustomStore({
    key: "id",
    onLoading() {
      // store.commit("store/setLoading", true);
    },
    onLoaded() {
      // store.commit("store/setLoading", false);
    },
    onModifying() {
      // store.commit("store/setLoading", true);
    },
    onModified() {
      // store.commit("store/setLoading", false);
    },
    async load(loadOptions) {
      // 파라미터 생성
      const params = CommonUtil.makeDxDataGridParams(loadOptions);
      try {
        if (accessType === CommonConst.ACCESS_TYPE_MY) {
          response = await getMyDeletedDesigns(params);
        } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
          response = await getCompanyDeletedDesigns(companyId, params);
        }
        return response.data;
      } catch (e) {
        // store.commit("store/setLoading", false);
        throw new Error("Data Loading Error");
      }
    },
    remove: async key => {
      try {
        if (accessType === CommonConst.ACCESS_TYPE_MY) {
          // console.log(`key:${key}`);
          await deleteDesign(key);
        } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
          await deleteCompanyDesign(companyId, key);
        }
        // return response.data;
      } catch (e) {
        // store.commit("store/setLoading", false);
        throw new Error("Data Loading Error");
      }
    },
  });
}

/**
 * 전문설계 상세 조회
 */
export async function getDesignDetail(accessType: string, id: number, companyId: number = null) {
  let response;
  // store.commit("store/setLoading", true);

  try {
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      response = await getMyDesignDetail(id);
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      response = await getCompanyDesignDetail(companyId, id);
    }
    return response.data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

/**
 * 전문설계 상세 수정
 */
export async function updateDesignDetail(
  accessType: string,
  id: number,
  companyId: number = null,
  updateDesign: Design,
) {
  // store.commit("store/setLoading", true);

  // 통신
  try {
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      await updateMyDesignDetail(id, updateDesign, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      await updateCompanyDesignDetail(companyId, id, updateDesign, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    }
    commonNotify(CommonConst.completeUpdate);
  } catch (e) {
    commonNotify(CommonConst.errorUpdate, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

/**
 * 전문설계 삭제상태로 수정
 */
export async function updateDeletedDesign(
  accessType: string,
  id: number,
  companyId: number = null,
  deleteDesign: Design,
) {
  // store.commit("store/setLoading", true);

  try {
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      await updateMyDeletedDesign(deleteDesign, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      await updateCompanyDeletedDesign(companyId, deleteDesign, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    }
  } catch (e) {
    commonNotify(CommonConst.errorDelete, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

/**
 * 전문설계 복원상태로 수정
 */
export async function updateRestoredDesign(accessType: string, id: number, companyId: number = null) {
  // store.commit("store/setLoading", true);

  // 통신
  try {
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      await updateMyRestoredDesign(id, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      await updateCompanyRestoredDesign(companyId, id, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    }
    commonNotify(CommonConst.completeRestore);
  } catch (e) {
    commonNotify(CommonConst.errorRestore, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

//----------------------------------
// 전문설계 결과물
//----------------------------------

/**
 * 전문설계 결과물 공통정보 조회
 */
export async function getDesignOutputCommonDTO(accessType: string, id: number, companyId: number) {
  let response;
  // store.commit("store/setLoading", true);

  try {
    // 통신
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      response = await getMyDesignOutputCommonDTO(id);
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      response = await getCompanyDesignOutputCommonDTO(companyId, id);
    }
    return response.data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

/**
 * 전문설계 결과물 기본정보 조회
 */
export async function getDesignOutputBasicDTO(accessType: string, id: number, companyId: number) {
  let response;
  // store.commit("store/setLoading", true);
  try {
    // 통신
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      response = await getMyDesignOutputBasicDTO(id);
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      response = await getCompanyDesignOutputBasicDTO(companyId, id);
    }
    return response.data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

/**
 * 전문설계 설계 내역 조회
 */
export async function getDesignDetailed(accessType: string, id: number, companyId: number) {
  let response;
  // store.commit("store/setLoading", true);

  try {
    // 통신
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      response = await getMyDesignDetailed(id);
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      response = await getCompanyDesignDetailed(companyId, id);
    }
    return response.data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

/**
 * 전문설계 자재 내역 조회
 */
export async function getDesignMaterial(accessType: string, id: number, companyId: number) {
  let response;
  // store.commit("store/setLoading", true);
  try {
    // 통신
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      response = await getMyDesignMaterial(id);
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      response = await getCompanyDesignMaterial(companyId, id);
    }
    return response.data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

/**
 * 전문설계 시방서 조회
 */
export async function getDesignSpecification(accessType: string, id: number, companyId: number) {
  let response;
  // store.commit("store/setLoading", true);

  try {
    // 통신
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      response = await getMyDesignSpecification(id);
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      response = await getCompanyDesignSpecification(companyId, id);
    }
    return response.data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

/**
 * 전문설계 설계도 조회
 */
export async function getDesignBlueprint(accessType: string, id: number, companyId: number) {
  let response;
  // store.commit("store/setLoading", true);
  try {
    // 통신
    if (accessType === CommonConst.ACCESS_TYPE_MY) {
      response = await getMyDesignBlueprint(id);
    } else if (accessType === CommonConst.ACCESS_TYPE_COMPANY) {
      response = await getCompanyDesignBlueprint(companyId, id);
    }
    return response.data;
  } catch (e) {
    commonNotify(CommonConst.errorGet, "error");
    throw e;
  } finally {
    // store.commit("store/setLoading", false);
  }
}

/**
 *  설계 결과 검색(Dx) - 조직별(운영자)
 */
export function getDesignSearchDataSource(accessType: string, companyId: number) {
  return new DataSource({
    store: new CustomStore({
      key: "id",
      loadMode: "processed",
      load: async (loadOptions: any) => {
        let params = `search=${loadOptions.searchValue}`;

        try {
          if (accessType === CommonConst.ACCESS_TYPE_ADMIN) {
            const { data } = await getCompanyDesignSearch(companyId, params);
            return data;
          } else {
            const { data } = await getSearchDesigns(params);
            return data;
          }
        } catch (e) {
          throw e;
        }
      },
      byKey: async key => {
        try {
          const { data } = await getCompanyDesignDetail(companyId, key);
          return data;
        } catch (e) {
          throw e;
        }
      },
      cacheRawData: false,
      useDefaultSearch: false,
    }),
    paginate: false,
  });
}
